<button (click)="close()" (keypress.enter)="close()" class="close-icon">
    <span hSrOnlyNoSnippet></span>
    <h-svg-icon [name]="'cross'"></h-svg-icon>
</button>
<div class="tab-list-container">
    @if ( product.variants && tabVariantToSelect() >= 0 ) {
    <h-tab-list
        [defaultSelectedTab]="tabVariantToSelect()"
        [shouldDisplayVerticalScrollbar]="true"
        [inheritPadding]="'0 2px'">
        @for (variantName of variantsList; track variantName) {
        <h-tab-item [focusable]="false">
            <ng-template hTabTitle>
                <p>
                    {{ variantName.tabTitle }}
                </p>
                <p class="label-small-bold-uppercase"> ({{ product.variants[variantName.pluralName].length }}) </p>
            </ng-template>
            <div [attr.aria-labelledby]="'toggle-title-' + variantName.name + '-variants'" [class]="'display-variants'">
                @for(variant of product.variants[variantName.pluralName]; let idx = $index; track variant.sku) {
                <h-variant-item
                    [style]="'height: auto'"
                    [boxType]="product.sku === variant.sku ? 'none' : 'link'"
                    [variant]="variant"
                    [currentProduct]="product"
                    [imageSrc]="variant.image"
                    [variantType]="variantName.name"
                    [formGroup]="variantsForm"
                    [formName]="variantName.name"
                    [routing]="true"
                    [selectedValue]="variant.sku ?? ''"
                    [isThinBorder]="true"
                    [imageAspectRatio]="imageAspectRatio"
                    [inputId]="'variant-item-' + getSkuToId(variant.sku) + '-' + variantName.name">
                </h-variant-item>
                }
            </div>
            @if (product.beltkitAttributes) {
            <div [class]="'variant-title paragraph-medium'">
                <span>
                    {{ product.beltkitAttributes[variantName.titleName] ?? "" | titlecase | hSlashSpacer }}
                </span>
                @if ( variantName.colorName ) {
                <span class="attributes-color">
                    {{ product.beltkitAttributes[variantName.colorName] ?? "" | titlecase | hSlashSpacer }}
                </span>
                }
            </div>
            }
        </h-tab-item>
        }
    </h-tab-list>
    }
</div>
